import { xget, xhttp } from "../Fetchv2.js";
import { MGST } from "../schemas/mg.schema-types.js";
import { MGSchema } from "../schemas/mg.schema.js";
import { allProfilesCatalog } from "./all-catalog.js";

export class Profiles {
	/**
	 * /pages/profile/:_id
	 */
	async getProfile(id: string) {
		return xget<{ profile: MGSchema.profiles }>(`/pages/profile/${id}`);
	}

	// Deprecated

	// CREATE <PROFILE>
	async createProfile(profile: MGSchema.profiles) {
		return xhttp<{ profile: MGSchema.profiles }>(`/pages/${profile.pgid}/profiles`, "POST", { profile });
	}

	// OBTENER <PROFILE[]>
	getAllProfiles() {
		return allProfilesCatalog;
	}

	// OBTENER <PROFILE.PGID[]>
	async getAllProfilesPgid(pgid: string) {
		return xget<{ profiles: MGSchema.profiles[] }>(`/pages/profiles/${pgid}`);
	}

	// ACTUALIZAR <PROFILE>
	async updateProfile(profile: MGSchema.profiles) {
		const { _id } = profile;

		return xhttp(`/pages/profile/${_id}`, "PUT", { profile });
	}

	// ACTUALIZAR BASIC <PROFILE> {_id, title, description}
	async updateProfileBasic(id: string, title: string, description: string) {
		return xhttp(`/pages/profile/${id}/basic`, "PUT", { title, description });
	}

	// ACTUALIZAR <PROFILE.TESTS[]>
	async updateProfileTests(id: string, tests: MGST.profiles.tests[]) {
		return xhttp(`/pages/profile/${id}/tests`, "PUT", { tests });
	}

	async updateProfileTestActive(prid: string, tsid: string, active: boolean) {
		return xhttp(`/pages/profile/${prid}/test/${tsid}/active`, "PUT", { active });
	}

	// ATUALIZAR <PROFILE.TESTS.OPTIONS[]>
	async updateProfileTestOptions(id: string, test: MGST.profiles.tests) {
		return xhttp(`/pages/profile/${id}/test/${test.id}`, "PUT", { test });
	}

	// ADD <PROFILETEST>
	async addProfileTest(id: string, test: MGST.profiles.tests) {
		return xhttp(`/pages/profile/${id}/addtest`, "PUT", { test });
	}

	// ELIMINAR <PROFILE>
	async deleteProfile(id: string) {
		return xhttp(`/pages/profile/${id}`, "DELETE");
	}

	// ELIMINAR <PROFILETEST>
	async deleteProfileTest(pid: string, tid: string) {
		return xhttp(`/pages/profile/${pid}/test/${tid}`, "DELETE");
	}
}
